import html2canvas from "html2canvas";

export const getImageFromElement = async (
  element: HTMLElement
): Promise<string> => {
  const canvas = await html2canvas(element, {
    backgroundColor: null,
    scale: 2,
  });
  return canvas.toDataURL("image/png");
};
